import { isProd } from './helper';

export const STAGING_MIGRATION_PARTNER_IDS = [9, 114, 558];

export const PROD_MIGRATION_PARTNER_IDS = [1, 71, 77];

export const getMigrationRelevantPartnerIds = () => {
  return isProd() ? PROD_MIGRATION_PARTNER_IDS : STAGING_MIGRATION_PARTNER_IDS;
};
